import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import network from './constant'
import utils from './utils'

// 抑制已知的遷移警告
configureCompat({
  COMPONENT_ASYNC: 'suppress-warning',
  RENDER_FUNCTION: 'suppress-warning',
  WATCH_ARRAY: 'suppress-warning',
  OPTIONS_DATA_MERGE: 'suppress-warning'
})

const app = createApp(App)

app.use(store)
app.use(router)
app.use(axios)

// Global properties
app.config.globalProperties.$network = network
app.config.globalProperties.$utils = utils

app.mount('#app')
